// this helper function returns a field in the Userdata object
// this will aid us in the future in moving away from a Userdata global if we decide to move
// forward with that
export const getUserdataField = field => Userdata[field]

export default getUserdataField
